import { Post, PostState, PostType } from 'common/interfaces/api';
import { SITE_BASE_URL } from 'config/env';
import {
  BadgeEnum,
  EmotionEnum,
  MediaTypeEnum,
  PostItemType,
  PostStatusEnum,
  PostTypeEnum,
  PrecheckEnum,
} from 'service/timeline';

export const convertOldPostToNewPost = (post: Post): PostItemType => {
  const newPost: PostItemType = {
    id: post.id,
    text: post.text,
    title: post.title,
    type: post.type as unknown as PostTypeEnum, // Convert PostType to PostTypeEnum
    uid: post.user_info.id,
    l_count: post.like_count,
    cmt_count: post.comment_count,
    s_count: post.share_count,
    v_count: post.view_count,
    is_mine: post.is_my_post,
    is_l: post.is_liked,
    is_s: post.is_shared,
    is_saved: post.is_saved,
    is_aff: post.is_affiliate,
    ca: post.content_access || { is_authorized: true, reason: '' },
    media: post.media
      ? post.media?.map((mediaItem) => ({
          type: mediaItem.type as unknown as MediaTypeEnum, // Convert MediaType to MediaTypeEnum
          data: {
            url: mediaItem.data?.url || '',
            width: mediaItem.data?.width || 0,
            height: mediaItem.data?.height || 0,
            thumbnail_url: mediaItem.data?.thumbnail_url,
            duration: mediaItem.data?.duration,
            title: mediaItem.data?.title,
            spectrum: mediaItem.data?.spectrum,
            source_name: mediaItem.data?.source_name,
            free_version: mediaItem.data?.free_version,
          },
        }))
      : [],
    user_info: {
      id: post.user_info.id,
      name: post.user_info.name,
      username: post.user_info.username,
      follow_count: Number(post.user_info.follow_count) || 0,
      avatar: post.user_info.avatar_url || '',
      badge: post.user_info.badge as unknown as BadgeEnum, // Convert Badge to BadgeEnum
      emotion: post.user_info.emotion as unknown as EmotionEnum, // Convert Emotion to EmotionEnum
      job: post.user_info.job,
      is_follow: post.user_info.is_followed,
      notif_on: post.user_info.is_turn_on_notification_btn, // Default value, not available in Post
      has_new: post.user_info.has_new_post || false,
      has_tip: post.user_info.has_tipped,
      is_adv: post.user_info.is_advertiser,
      is_cre: post.user_info.is_creator,
      live: post.user_info.in_live || false,
    },
    created: post.created_at,
    status: post.status as unknown as PostStatusEnum,
    precheck: 'none' as unknown as PrecheckEnum, // Default value, need to map from precheck_logs if available
    published: post.published_at,
    streaming: post.streaming || null,
    free_mins: post.free_minutes || 0,
    user_topic: post.user_topic || null,
    is_pinned: post.is_pinned || false,
  };

  return newPost;
};

export const checkIsContentLocked = (post: PostItemType) => {
  if (!post || post.is_mine) return false;
  return !post.ca?.is_authorized;
};

export const convertPostStatusEnumToState = (status: PostStatusEnum) => {
  switch (status) {
    case PostStatusEnum.Activated:
      return PostState.Activated;
    case PostStatusEnum.OnProcessing:
      return PostState.OnProcessing;
    case PostStatusEnum.Disable:
      return PostState.Disable;
  }
};

export const convertPostTypeEnumToType = (type: PostTypeEnum) => {
  switch (type) {
    case PostTypeEnum.Free:
      return PostType.Free;
    case PostTypeEnum.Paid:
      return PostType.Paid;
    case PostTypeEnum.Plus:
      return PostType.Plus;
  }
};

export const getPostUrlToShare = (post: PostItemType) => {
  if (!post || !post.user_info) return '';
  return `${SITE_BASE_URL}/${post.user_info?.username}/posts/${post.id}`;
};
